import { CFContainer, CFIconBadge, CFText } from '@connectrn/ds-ui-web';

type NoPermissionAlertProps = {
	message: string;
};

export const NoPermissionAlert: React.FC<NoPermissionAlertProps> = ({ message }) => {
	return message === '' ? (
		<CFContainer
			align="top-left"
			background="strawberry-2"
			border="chromatic-strawberry"
			borderRadius="c"
			dir="horizontal"
			gap="d"
			pad="d"
		>
			<CFIconBadge colorway="strawberry" icon="alert-circle" size="md" strength="midtone" />
			<CFContainer flex={1} gap="b">
				<CFText.Body>
					Account does not have permission to review. If you think this is incorrect, please contact your
					administration.
				</CFText.Body>
				<CFText.Body>
					For other check out options, go to cico.connectrn.com and have the clinicians scan from there or from a
					printed QR code.
				</CFText.Body>
			</CFContainer>
		</CFContainer>
	) : (
		<CFContainer
			align="top-left"
			background="strawberry-2"
			border="chromatic-strawberry"
			borderRadius="c"
			dir="horizontal"
			gap="d"
			pad="d"
		>
			<CFIconBadge colorway="strawberry" icon="alert-circle" size="md" strength="midtone" />
			<CFContainer flex={1} gap="b">
				<CFText.Body>Username or password is incorrect. Please try again.</CFText.Body>
				<CFText.Body>
					For other check out options, go to cico.connectrn.com and have the clinicians scan from there or from a
					printed QR code.
				</CFText.Body>
			</CFContainer>
		</CFContainer>
	);
};
